{
  "items": [
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-01.mp4",
      "description": "The video shows one woman, a young adult female of Asian descent with a fair skin tone and dark black hair pulled back neatly away from her face. The woman is wearing safety glasses, clear protective safety goggles, and a coat, a white lab coat, over a gray, light gray t-shirt, along with a blue lanyard holding an identification badge around her neck, and white protective gloves on her hands. The woman has a calm, confident, slightly smiling visible expression, with her arms crossed in front of her in one visible moment. The setting is an indoor science laboratory environment, blurred softly out of focus behind the woman, showing several other people, additional scientists or lab workers, wearing similar white lab coats and safety glasses, including a man on the left working with glass laboratory equipment, a funnel, and a metal stand, an older man with gray hair in the middle background holding a digital tablet, and a woman on the right handling a small glass vial. The laboratory contains various scientific instruments, a red toolbox, and small black and white robotic or model kits on a table on the right side of the frame. The lighting is bright, even, and cool toned, consistent with fluorescent or LED laboratory lighting, evenly illuminating the woman's face without harsh shadows. The color palette is cool and clean, dominated by white, light blue, and gray tones, with small accents of blue from the lanyard and red from the toolbox. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or scientific style stock video with a shallow depth of field, keeping the laboratory and additional people softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "laboratory equipment",
        "glass equipment",
        "funnel",
        "metal stand",
        "tablet",
        "vial",
        "toolbox",
        "robotic kits",
        "lab coat",
        "safety glasses",
        "lanyard",
        "lighting"
      ],
      "attributes": [
        "calm",
        "confident",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "cool tone",
        "clean",
        "corporate",
        "scientific",
        "laboratory",
        "woman",
        "lab coat",
        "white coat",
        "safety glasses",
        "goggles",
        "gloves",
        "lanyard",
        "badge",
        "toolbox",
        "red",
        "blue",
        "white",
        "gray",
        "scientists",
        "robot kit",
        "vial",
        "tablet"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-02.mp4",
      "description": "The video shows one man, a middle aged adult male with a fair skin tone and short, gray, silver hair swept back and upward. The man is wearing eyeglasses, black round framed eyeglasses, and is smiling broadly with his mouth open, showing white teeth, giving a warm, confident, friendly visible expression. The man is wearing a jacket, a gray blazer or sport coat, layered over a black t-shirt, with a small dark pocket square visible in the breast pocket. The setting is an indoor industrial style environment, blurred softly out of focus behind the man, showing exposed ceiling ductwork, metal pipes, and structural beams overhead, dark black framed windows with a warm orange, red toned light glowing through from outside, and a wooden table with a chair and a small water bottle visible in the lower left of the frame. The lighting is dramatic and warm, consistent with a single directional light source illuminating the man's face while the surrounding space remains dim and shadowed. The color palette is dark and moody, dominated by black, gray, and dark brown tones, with warm orange and red accents from the window light. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or editorial style stock video with a shallow depth of field, keeping the industrial background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "ductwork",
        "pipes",
        "ceiling beams",
        "windows",
        "table",
        "chair",
        "water bottle",
        "blazer color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "confident",
        "friendly",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "dramatic lighting",
        "moody",
        "dark tone",
        "warm tone",
        "corporate",
        "editorial",
        "industrial",
        "man",
        "male",
        "gray hair",
        "silver hair",
        "eyeglasses",
        "glasses",
        "blazer",
        "jacket",
        "black",
        "gray",
        "pocket square",
        "ductwork",
        "pipes",
        "window",
        "table",
        "chair"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-03.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, light freckles, and brown hair pulled back with a few loose strands framing her face. The woman is wearing drop earrings, gold teardrop shaped dangling earrings, and has hazel, green eyes, with a broad, open mouthed smile showing white teeth, giving a warm, confident, friendly visible expression. The woman is wearing a top, a dark navy blue or black blazer or jacket with a collar. The setting is an indoor modern office environment, blurred heavily out of focus behind the woman, showing glass walls, glass panels, and indistinct office furniture and lighting, with soft bokeh highlights and a bright lens flare visible across the frame in one visible moment. The lighting is bright, soft, and natural, consistent with daylight coming through the glass office walls, evenly illuminating the woman's face. The color palette is cool and neutral, dominated by white, gray, blue, and light tones, with warm skin tones on the woman's face. The composition is an extreme close up, closeup, tight face framing, with the woman's face filling most of the frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a corporate or professional portrait style stock video with a shallow depth of field, keeping the glass office background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "glass walls",
        "glass panels",
        "office furniture",
        "bokeh",
        "lens flare",
        "earrings",
        "blazer color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "confident",
        "friendly",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "bokeh",
        "lens flare",
        "bright lighting",
        "natural light",
        "cool tone",
        "corporate",
        "professional",
        "office",
        "woman",
        "freckles",
        "brown hair",
        "hazel eyes",
        "green eyes",
        "drop earrings",
        "earrings",
        "gold",
        "navy blue",
        "black",
        "blazer",
        "glass wall"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-04.mp4",
      "description": "The video shows one man, a young adult male with a dark skin tone and short, dark black hair, along with a light beard and mustache. The man has dark brown eyes and a gentle, soft smile with closed or slightly parted lips, giving a warm, calm, friendly visible expression. The man is wearing a sweater, a brown, tan colored v neck sweater, layered over a collared shirt, a blue, light blue button up shirt underneath. The man is seated on a sofa, a gray, light gray couch. The setting is an indoor home environment, blurred softly out of focus behind the man, showing dark framed glass doors or windows on either side of the frame, and a blurred modern kitchen in the background with white cabinets, hanging pendant lights, and open shelving. The lighting is soft, bright, and natural, consistent with daylight filling the room, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by tan, brown, light blue, white, and gray tones. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or corporate style stock video with a shallow depth of field, keeping the kitchen and glass doors background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "glass doors",
        "windows",
        "kitchen",
        "cabinets",
        "pendant lights",
        "shelving",
        "sofa",
        "couch",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "calm",
        "friendly",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "neutral tone",
        "lifestyle",
        "corporate",
        "home",
        "man",
        "male",
        "beard",
        "mustache",
        "sweater",
        "tan",
        "brown",
        "blue",
        "shirt",
        "sofa",
        "couch",
        "kitchen",
        "cabinets",
        "pendant light",
        "glass door"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-05.mp4",
      "description": "The video shows one man, a middle aged adult male of Asian descent with a fair skin tone and short, dark hair with visible gray strands. The man is wearing eyeglasses, dark tortoiseshell, brown thick framed eyeglasses, and has a light gray goatee and mustache, with a broad, open mouthed smile showing white teeth, giving a warm, friendly, joyful visible expression. The man is wearing a top, a blue, light blue button up collared shirt. The setting is an indoor home office environment, blurred softly out of focus behind the man, showing a white shelving unit or bookcase, a small potted plant on top of the shelf, and a bright window on the left side of the frame letting in soft natural light. The lighting is bright, soft, and even, consistent with natural daylight filling the room, evenly illuminating the man's face without harsh shadows. The color palette is bright and neutral, dominated by white, light blue, tan, and gray tones, with a small green accent from the potted plant. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or professional portrait style stock video with a shallow depth of field, keeping the background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "shelving unit",
        "bookcase",
        "potted plant",
        "window",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "friendly",
        "joyful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "neutral tone",
        "corporate",
        "professional",
        "home office",
        "man",
        "male",
        "eyeglasses",
        "glasses",
        "tortoiseshell",
        "goatee",
        "mustache",
        "gray hair",
        "blue",
        "shirt",
        "shelving unit",
        "bookcase",
        "plant",
        "window",
        "white"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-06.mp4",
      "description": "The video shows one man, a young adult male with a tan or olive skin tone and short, dark black hair, along with a full, thick dark beard covering his jaw and chin. The man has dark brown eyes and a subtle, neutral, slightly closed lip smile, giving a calm, thoughtful visible expression, with his gaze directed slightly off to the side. The man is wearing a top, a gray button up collared shirt. The setting is an indoor office environment, blurred softly out of focus behind the man, showing a gray cubicle partition or wall panel on the left side of the frame, and a wood toned pegboard or shelving display holding small colorful objects on the right side of the frame, with a teal, green ceiling element visible in the upper right corner. The lighting is soft and diffused, consistent with overcast or even indoor lighting, evenly illuminating the man's face without harsh shadows. The color palette is neutral and muted, dominated by gray, tan, and wood brown tones, with small colorful accents from the objects on the pegboard and a teal accent from the ceiling. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or workplace style stock video with a shallow depth of field, keeping the office background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "cubicle partition",
        "wall panel",
        "pegboard",
        "shelving display",
        "ceiling",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "calm",
        "thoughtful",
        "neutral",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "neutral tone",
        "muted tone",
        "corporate",
        "workplace",
        "office",
        "man",
        "male",
        "beard",
        "gray",
        "shirt",
        "cubicle",
        "pegboard",
        "wood",
        "teal",
        "colorful"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCorporate-07.mp4",
      "description": "The video shows one woman, an elderly adult female with a fair skin tone and short, gray, silver hair. The woman is wearing eyeglasses, round wire framed eyeglasses, small stud earrings, and a silver choker necklace, with pink, rose colored lipstick, and a broad, open mouthed smile showing white teeth, giving a warm, joyful, friendly visible expression. The woman is wearing a top, a dark green button up shirt, along with bag straps visible over one shoulder. The setting is an outdoor city street intersection, blurred softly out of focus behind the woman, showing several cars, a black car, an orange car, and a yellow van or bus, parked or driving along the road, tall city buildings, a traffic light, and a pedestrian wearing a green shirt crossing the street. The lighting is warm and bright, consistent with low angle sunlight or sunset light shining from behind the woman, creating a warm glow around her hair and skin. The color palette is warm and vibrant, dominated by green, orange, yellow, and tan tones, with gray from the street and buildings. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or corporate style stock video with a shallow depth of field, keeping the street and vehicles background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "cars",
        "vehicles",
        "buildings",
        "traffic light",
        "street",
        "pedestrian",
        "bag straps",
        "shirt color",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "friendly",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "backlight",
        "golden light",
        "bright lighting",
        "natural light",
        "warm tone",
        "vibrant",
        "urban",
        "city",
        "lifestyle",
        "corporate",
        "woman",
        "elderly",
        "senior",
        "gray hair",
        "silver hair",
        "eyeglasses",
        "glasses",
        "necklace",
        "choker",
        "green",
        "shirt",
        "bag",
        "strap",
        "cars",
        "traffic light",
        "street",
        "buildings"
      ]
    }
  ]
}
